// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const CustomerSourceType = {
  POS: {
    Name: 'POS',
    Value: 'pos',
  },
  Admin: {
    Name: 'Admin',
    Value: 'admin',
  },
  Import: {
    Name: 'Import',
    Value: 'import',
  },
  Web: {
    Name: 'Web',
    Value: 'web',
  },
} as const

export type CustomerSourceTypeValue =
  (typeof CustomerSourceType)[keyof typeof CustomerSourceType]['Value']
